import { MainLayout } from 'components/Layout';
import { useEffect } from 'react';

export const RiskDisclosurePolicy = () => {
  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // change to 'auto' if you want instant
      });
    }, []);
  return (
    <MainLayout
      title="Risk Disclosure | Fundo"
      description="Important information about risks associated with using Fundo."
    >
      {/* HEADER */}
      <section className="max-w-3xl">
        <p className="text-xs uppercase tracking-[0.35em] text-[#8b5e3c]">Risk Disclosure</p>

        <h1 className="mt-4 font-serif text-5xl leading-[0.95] tracking-[-0.04em] text-[#1b140f] sm:text-6xl">
          Understand the risks before you participate.
        </h1>

        <p className="mt-6 text-lg leading-8 text-[#4f4034]">
          This document outlines important risks associated with using Fundo, including
          participation in farming activities, marketplace transactions, and financial services.
        </p>

        <p className="mt-4 text-sm text-[#8b5e3c]">Last updated: April 2026</p>
      </section>

      {/* CONTENT */}
      <section className="mt-20 max-w-3xl space-y-14">
        {/* GENERAL */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">1. General Risk Acknowledgment</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            By using Fundo, you acknowledge that all activities on the platform involve risk. You
            agree that you are solely responsible for your decisions and outcomes.
          </p>
        </div>

        {/* NO GUARANTEES */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">2. No Guaranteed Returns</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo does not guarantee any financial returns, profits, or outcomes. Any earnings or
            results shown on the platform are indicative and may vary significantly.
          </p>
        </div>

        {/* AGRICULTURE RISKS */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">3. Agricultural Risks</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Farming activities are subject to real-world risks, including but not limited to weather
            conditions, pests, diseases, soil variability, and operational challenges. These factors
            may impact production and returns.
          </p>
        </div>

        {/* VIRTUAL FARMING */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">4. Virtual Farming Participation</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Participation in virtual or remote farming does not eliminate exposure to real-world
            agricultural risks. Outcomes depend on actual farm performance and external conditions.
            Fundo does not act as an investment manager or guarantee results.
          </p>
        </div>

        {/* MARKET RISKS */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">5. Market & Pricing Risks</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Prices of agricultural products may fluctuate due to supply, demand, seasonal factors,
            and broader market conditions. Auction outcomes and marketplace transactions are not
            guaranteed to meet expectations.
          </p>
        </div>

        {/* FINANCIAL RISKS */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">6. Financial Risks</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Financial services accessed through Fundo may involve repayment obligations, interest,
            or other costs. Users should carefully assess their financial capacity before engaging
            in such services.
          </p>
        </div>

        {/* THIRD PARTY */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">7. Third-Party Risks</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo relies on third-party providers for certain services, including payments and
            financial products. Fundo is not responsible for the performance, reliability, or
            actions of these providers.
          </p>
        </div>

        {/* TECHNOLOGY */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">8. Technology & Access Risks</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Access to Fundo may depend on internet connectivity, mobile networks, or USSD systems.
            Service interruptions, delays, or technical issues may occur and affect user experience.
          </p>
        </div>

        {/* DECISION RESPONSIBILITY */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">9. User Responsibility</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            You are responsible for evaluating all risks and making informed decisions. Fundo does
            not provide investment advice or guarantees.
          </p>
        </div>

        {/* LIMITATION */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">10. Limitation of Liability</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo is not liable for losses arising from farming activities, marketplace
            transactions, financial services, or platform usage.
          </p>
        </div>

        {/* UPDATES */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">11. Updates to This Policy</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            This Risk Disclosure may be updated periodically. Continued use of Fundo indicates
            acceptance of any updates.
          </p>
        </div>

        {/* CONTACT */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">12. Contact</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            For questions regarding this Risk Disclosure, contact:
          </p>

          <p className="mt-4 text-sm text-[#8b5e3c]">fundofarmer@gmail.com</p>
        </div>
      </section>
    </MainLayout>
  );
};
